/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line unused-imports/no-unused-imports
import { css, styled, jsx } from "@compiled/react";

import QuestionCircleIcon from "@atlaskit/icon/core/question-circle";
import { N0 } from "@atlaskit/theme/colors";
import { token } from "@atlaskit/tokens";
import Tooltip, { TooltipPrimitive } from "@atlaskit/tooltip";

const contentStyles = css({
    fontSize: 12,
    display: "flex",
    flexDirection: "column",
    gap: token("space.200", "16px")
});

const contentEmphasisStyles = css({
    fontWeight: token("font.weight.bold")
});

export const ContentContainer = styled(TooltipPrimitive)({
    background: token("color.background.neutral.subtle", N0),
    borderRadius: "4px",
    boxShadow:
        // eslint-disable-next-line local/ensure-wac-token-usage
        "rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em",
    boxSizing: "content-box",
    padding: token("space.150", "12px"),
    width: "315px",
    lineHeight: "18px"
});

export const SiteNameFieldTooltip = () => {
    return (
        <Tooltip
            position="right-start"
            // @ts-ignore
            component={ContentContainer}
            content={
                <div css={contentStyles}>
                    <span>
                        When you sign up for a product, your site name
                        determines the URL. For example, if you enter{" "}
                        <span css={contentEmphasisStyles}>Acme</span>, the site
                        URL will be{" "}
                        <span css={contentEmphasisStyles}>acme</span>
                        .atlassian.net.
                    </span>

                    <span>
                        Site name must be at least three characters (numerals or
                        lowercase letters only) and can’t start or end with a
                        hyphen (-).
                    </span>

                    <span>
                        {/* eslint-disable-next-line @atlassian/a11y/anchor-ambiguous-text */}
                        <a href="https://support.atlassian.com/organization-administration/docs/update-your-product-and-site-url">
                            Learn more
                        </a>{" "}
                        about naming your site.
                    </span>
                </div>
            }
        >
            {(tooltipProps) => (
                <span {...tooltipProps}>
                    <QuestionCircleIcon color="currentColor" label="" />
                </span>
            )}
        </Tooltip>
    );
};
